import COSTS from "./allCosts";



const oracleBuilder = (oracle, font, width, height, isLong) => {
	// line stuff
	const lineHeight = isLong ? 29 : 33;
	const lineBreak = isLong ? 32 : 38;
	// sizes for mana cost icons
	const iconWidth = isLong ? 29: 33;
	const iconHeight = isLong? 29: 33;
	const canvas = document.createElement("canvas");
	canvas.height = height;
	canvas.width = width;
	const ctx = canvas.getContext("2d");
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	ctx.font = font;
	const images = [];
	// split oracle text into lines


	if (oracle.length > 0) {
		// abilities are split by newlines
		// we remove oracle text and add a space to cost drawing to make the checker pick it up. 
		const lines = oracle.replace(/\(.+\)\n/g, "").replace(/"{/g, '" {').split("\n");
		let currentY = lineBreak;
		lines.forEach((line) => {
		if (line.search(/{*}/) > -1) {
				// handle ones with cost
				let currentX = 0;
				// space out all costs
				line = line.replace(/{.}/g, "$& ");
				line = line.replace(/{.\/.}/g, "$& ");
				let words = line.split(" ");
				let idx = 1;
				while (words.length > 0 && idx <= words.length) {
					const thisWord = words[idx - 1];
					// check if this word is a cost
					if (thisWord.search(/{.}/) > -1 || thisWord.search(/{.\/.}/) > -1) {
						if (idx !== 1) {
							// if this isn't the first word in the line draw what we have.
							const printString = words.slice(0, idx - 1).join(" ");
							const textWidth = ctx.measureText(printString).width;
							ctx.fillText(printString, currentX, currentY);
							// update text offset
							currentX = currentX + textWidth + 2;
							// update words
							words = words.splice(idx - 1);
						}
						// add image to the list of images to draw
						// filter out any ' or ( characters 
						const thisCost = thisWord.replace(/'/g,"").replace(/\(/g,"");
						
						images.push({
							imgSrc: COSTS[thisCost],
							xPos: currentX + 3,
							yPos: currentY - iconHeight + 4,
						});
						// update x offset
						currentX = currentX + iconWidth + 4;
						// remove the icon from the array
						words = words.splice(1);
						// move on to next word
						idx = 1;
					} else {
						const toPrint = words.slice(0, idx).join(" ");
						const printedWidth = currentX + ctx.measureText(toPrint).width;
						if (printedWidth > width - 2) {
							// adjust for last word on its own line.
							if (idx === 1) {
								idx = 2;
							}
							// remove the last word and draw
							ctx.fillText(
								words.slice(0, idx - 1).join(" "),
								currentX,
								currentY
							);
							// update stuff
							words = words.splice(idx - 1);
							currentY = currentY + lineHeight;
							currentX = 0;
							idx = 1;
						} else {
							// go to next word
							idx++;
						}
					}
					// print whatever is in the array
				}
				ctx.fillText(words.slice(0, idx).join(" "), currentX, currentY);
				// shift by linebreak ever new ability
				currentY = currentY + lineBreak;
			} else {
				// split line into words
				let words = line.split(" ");
				let idx = 1;
				while (words.length > 0 && idx <= words.length) {
					// recreate the line one word at a time and check if fits
					const toPrint = words.slice(0, idx).join(" ");
					const printedWidth = ctx.measureText(toPrint).width;
					if (printedWidth > width - 2) {
						// adjust for last word on its own line.
						if (idx === 1) {
							idx = 2;
						}
						// remove the last word and draw
						ctx.fillText(words.slice(0, idx - 1).join(" "), 0, currentY);
						// update stuff
						words = words.splice(idx - 1);
						currentY = currentY + lineHeight;
						idx = 1;
					} else {
						// go to next word
						idx++;
					}
				}
				// print whatever is in the array
				ctx.fillText(words.slice(0, idx).join(" "), 0, currentY);
				// shift by linebreak every new ability
				currentY = currentY + lineBreak;
			}
		});
	}
	// return everything as promises to make loading easier
	if (images.length === 0) {
		// if no images to load just send it back
		return new Promise((resolve, reject) => {
			resolve(canvas.toDataURL("image/png"));
		});
	} else {
		// wait for all loads to resolve
		return Promise.all(
			images.map((image,index) => {
				return new Promise((resolve, reject) => {
					const img = document.createElement("img");
					img.src = image.imgSrc;
					img.addEventListener("load", () => resolve(img));
					img.addEventListener("error", ()=> reject(`error loading image ${index}`))
				});
			})
		)
			.then((imgs) => {
				// draw all the images to the canvas
				imgs.forEach((img, idx) => {
					ctx.drawImage(
						img,
						images[idx].xPos,
						images[idx].yPos,
						iconWidth,
						iconHeight
					);
				});
				// return the canvas
				return canvas.toDataURL("image/png");
			})
			.catch((e) => console.error(`Some error with drawing oracle ${e}`));
	}
};

export default oracleBuilder;
